import Box from '@mui/material/Box';
import React, { useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { MYMRoutes } from '../../MYMRoutes';
import { BreadcrumbItemContext } from '../provider/BreadcrumbItemContextProvider';
import { MyMLabel } from '../ui-elements/MyMLabel';
import { NavigateLink } from './NavigateLink';
import { utility } from '../utility';
import { useMediaQuery } from '../hooks/useMediaQuery';

/**
 * パンくずリスト Component
 */
const Breadcrumbs = (props) => {

  const breadcrumbs = useBreadcrumbs(MYMRoutes);
  const { breadcrumbItem } = useContext(BreadcrumbItemContext);
  const queryParam = useParams();
  const { controlSettings } = props;
  const lastBreadCrumb = breadcrumbs[breadcrumbs.length - 1];
  const isMobile = useMediaQuery('(max-width:430px)');

  if (!lastBreadCrumb.match.route.breadcrumb ||
    lastBreadCrumb.match.route.path === 'MyM102') {
    return <></>;
  }

  const getBreadcrumbText = (breadcrumbKey) => {

    if (!breadcrumbKey) return '';

    const controlLabel = controlSettings.LabelList[breadcrumbKey];
    if (controlLabel) return controlLabel;

    if (breadcrumbKey.startsWith(':context') && breadcrumbItem) {
        return breadcrumbItem;
    }

    if (breadcrumbKey.startsWith(':') && queryParam) {
      const paramValue = queryParam[breadcrumbKey.substr(1)];
      if (paramValue)
        return paramValue;
    }

    return '';
  }

  return (
    <Box className="pt-1 d-flex align-items-end">
      {breadcrumbs.map(({ match, breadcrumb }, index) => (
        <React.Fragment key={match.pathname}>
          {index > 1 && match.route.breadcrumb && <MyMLabel className='px-1'> {controlSettings.LabelList.lnkBreadcrumbsArrow} </MyMLabel>}
          {
            index === breadcrumbs.length - 1
              ? <MyMLabel>{!isMobile ? getBreadcrumbText(match.route.breadcrumb) : utility.convertEllipsisFormat(getBreadcrumbText(match.route.breadcrumb), 14)}</MyMLabel>
              : <NavigateLink tag={Link} to={match.pathname}>
                <MyMLabel>{!isMobile ? getBreadcrumbText(match.route.breadcrumb) : utility.convertEllipsisFormat(getBreadcrumbText(match.route.breadcrumb),5)}</MyMLabel>
                </NavigateLink>
          }
        </React.Fragment>
      ))}
    </Box>
  );
}
export default Breadcrumbs;

